import type { Json } from "./database.types";
import { supabase } from "./supabase";

export async function insertAuditLog(entry: {
	user_id: string;
	action: string;
	entity_type: string;
	entity_id: string;
	source: string;
	changes?: Record<string, Json | undefined>;
	metadata?: Record<string, Json | undefined>;
}) {
	await supabase.from("audit_log").insert({
		user_id: entry.user_id,
		action: entry.action,
		entity_type: entry.entity_type,
		entity_id: entry.entity_id,
		source: entry.source,
		changes: (entry.changes as Json) ?? null,
		metadata: (entry.metadata as Json) ?? null,
	});
}
